var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ns-slotted-dropdown",
    {
      staticClass: "variant-dropdown",
      attrs: {
        id: "variantDropdown",
        "selected-text": _vm.variantDropdownPlaceholder,
        selected: _vm.variantIndex,
        "stay-closed": _vm.isTouchDevice
      }
    },
    _vm._l(_vm.variants, function(item) {
      return _c(
        "paper-item",
        {
          key: item.id,
          staticClass: "variant-dropdown-item",
          attrs: { value: item.sku }
        },
        [
          _c("div", {
            staticClass: "dropdown-item-icon",
            style: { backgroundColor: item.shade }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown-item-label" }, [
            _vm._v(_vm._s(item.variantDropdownLabel))
          ])
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }